import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';

@Component({
  selector: 'sd-cart-list-item-gift',
  imports: [SdvorIconComponent],
  templateUrl: './cart-list-item-gift.component.html',
  styleUrls: ['./cart-list-item-gift.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartListItemGiftComponent {
  protected readonly iconTypes = IconTypes;
}
